import type { ChartDataItem } from 'utils/chart-options';
import type { GoalTargetProjectionProps } from './types';

export const getGoalTargetProjectionData = ({
  targetAmount,
  savedSoFar,
  contributionAmount,
  startDate,
  targetDate,
}: GoalTargetProjectionProps): ChartDataItem[] => {
  if (contributionAmount <= 0) {
    return [{ category: startDate.toFormat('MMM yyyy'), target: targetAmount }];
  }

  // startDate is always the start of a month; targetDate/endDate is always the end.
  const endDate = targetDate || startDate.plus({ months: Math.floor(targetAmount / contributionAmount) });
  const data: ChartDataItem[] = [
    {
      category: startDate.toFormat('MMM yyyy'),
      target: Math.max(savedSoFar, contributionAmount),
    },
  ];
  const durationInMonths = endDate.diff(startDate, 'months').months;

  if (durationInMonths > 2) {
    const midDate = startDate.plus({ months: Math.floor(durationInMonths / 2) }).endOf('month');
    data.push({
      category: midDate.toFormat('MMM yyyy'),
      target: Math.abs((savedSoFar || 0) + contributionAmount * midDate.diff(startDate, 'months').months),
    });
  }
  if (durationInMonths > 1) {
    data.push({
      category: endDate.toFormat('MMM yyyy'),
      target: Math.max(targetAmount, Math.abs(contributionAmount * durationInMonths)),
    });
  }

  return data;
};
